import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { RouteEnum } from '@shared/services/route-enum';

@Component({
    selector: 'app-appointment-recap-component',
    templateUrl: './appointment-recap.component.html',
})
export class AppointmentRecapComponent {
    @Input() webCallBackMedical: any;
    @Input() appointment: any;
    @Output() toogleModalRdvMedical = new EventEmitter<number>();

    constructor(private router: Router) {}

    navigateToAppointmentDetails() {
        this.router.navigateByUrl(RouteEnum.appointmentDetails);
    }
    goToEditRdvMedical() {
        this.router.navigateByUrl(
            '/souscription/appointment/appointment-details/' +
                this.appointment.praticien.idApi
        );
    }
}
